<template>
    <div v-if="page">
        <div class="container pb-5">
            <!-- Page Title -->
            <div class="pt-5 pb-5 d-flex">
                <h1 class="m-0">{{ page.title }}</h1>
            </div>
            <!-- End Page Title -->

            <!-- Content -->
            <div v-html="page.content"></div>
            <!-- End Content -->
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        page() {
            return this.$store.getters.pageBySlug(this.$route.params.slug);
        }
    }
};
</script>

